import { useId, useRef } from "react";
import { C } from "./theme";
import { BottomSheet } from "./BottomSheet";

// How a page works, as numbered lines in a sheet from the bottom of the screen ("How to use …").
// The one design for help everywhere; each page's words live in helpContent.js.
export function HelpSheet({ title, lines, onClose }) {
  const doneRef = useRef(null);
  const titleId = useId();
  return (
    <BottomSheet labelledBy={titleId} startRef={doneRef} onClose={onClose}>
      <h2 id={titleId} style={{ margin: "0 0 16px", fontSize: 17, fontWeight: 700 }}>{title}</h2>
      <ol style={{ listStyle: "none", margin: 0, padding: 0, display: "grid", gap: 12 }}>
        {lines.map((line, i) => (
          <li key={i} style={{ display: "flex", gap: 10, alignItems: "flex-start" }}>
            <span aria-hidden="true" style={{ minWidth: 22, height: 22, borderRadius: "50%", background: C.accent, color: C.onAccent, fontSize: 12, fontWeight: 700, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0, marginTop: 1 }}>{i + 1}</span>
            <span style={{ fontSize: 15, lineHeight: 1.5 }}>{line}</span>
          </li>
        ))}
      </ol>
      <div style={{ textAlign: "center", marginTop: 20 }}>
        <button ref={doneRef} onClick={onClose}
          style={{ minHeight: 44, background: C.accent, color: C.onAccent, border: "none", borderRadius: C.rsm, padding: "0 32px", fontSize: 15, fontWeight: 700, cursor: "pointer", fontFamily: "inherit" }}>
          Got it
        </button>
      </div>
    </BottomSheet>
  );
}
